import { IColumnSort } from '../apiTypes/endpoints/people';

export const getSortParams = (sort?: IColumnSort | Array<IColumnSort | undefined>) =>
  (Array.isArray(sort) ? sort : [sort])
    .filter((param) => param != null)
    .map((param) => `${param!.columnTextId}-${param!.direction.toUpperCase()}`)
    .join(',');
